import axios from 'axios';

import { API_BASE_URL } from './constant';
import { REFRESH_TOKEN, ACCESS_TOKEN } from './keywords';
import { LOGIN_PATH } from 'router/pathName';

const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem(REFRESH_TOKEN);
    const requestBody = { refresh: refreshToken };
    const res = await axios.post(
      `${API_BASE_URL}/v1/token/refresh`,
      requestBody
    );
    const { access, refresh } = res.data;
    localStorage.setItem(REFRESH_TOKEN, refresh);
    localStorage.setItem(ACCESS_TOKEN, access);
  } catch (e) {
    throw e;
  }
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    config.headers['Authorization'] = `Bearer ${accessToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (originalRequest.url === '/v1/token') {
      return Promise.reject(error);
    }

    originalRequest._retryCount = originalRequest._retryCount || 0;

    if (error.response.status === 401 && originalRequest._retryCount < 3) {
      originalRequest._retryCount += 1;

      try {
        console.log('Invalid token, attempting to refresh...');
        await refreshAccessToken();
        return axiosInstance(originalRequest);
      } catch (e) {
        if (originalRequest._retryCount >= 3) {
          console.log('Failed to refresh token after 3 attempts.');
          window.location.replace(LOGIN_PATH);
        }
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
